import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { getPaymentsMdaCount } from "common/services/payments.service";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import useQueryState from "Components/Hooks/UseQueryState";
import { getYearDateRange } from "common/lib/dateUtils";
import { Link } from "react-router-dom";

const NumberOfMdas = () => {
  const [loading, setLoading] = useState(false);
  const [totalMDAs, setTotalMDAs] = useState(0);

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(selectedYear);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentsMdaCount({
          startDate: firstDay,
          endDate: lastDay,
        });
        setTotalMDAs(response?.mdaCount || 0);
      } catch (error) {
        console.warn("Error fetching total MDAs", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  return (
    <Link to={"/mdas"}>
      <Card className="card-animate mb-4 card-bottom-primary">
        <CardBody className="">
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">Number of MDAs</p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value">
                  <CountUp
                    start={0}
                    end={totalMDAs}
                    decimals={0}
                    duration={1}
                    separator=","
                  />
                </span>
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-info mb-0 me-2">
                  {selectedYear}
                </span>
                fiscal year
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="briefcase" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
};

export default NumberOfMdas;
